import React, {Component} from 'react'
import { DragSource } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import Box from './Box'

const boxSource = {
	beginDrag(props) {
		const { id, left, top, title } = props
		return { id, left, top, title }
	},
}

function getStyles(props) {
	const { left, top, isDragging } = props
	const transform = `translate3d(${left}px, ${top}px, 0)`

	return {
		position: 'absolute',
		transform,
		WebkitTransform: transform,
		opacity: isDragging ? 0 : 1,
		height: isDragging ? 0 : '',
	}
}

class DraggableBox extends Component {
	componentDidMount() {
		const { connectDragPreview } = this.props
		if (connectDragPreview) {
			connectDragPreview(getEmptyImage(), {
				captureDraggingState: true,
			})
		}
	}

	onBoxDown(keyCode,id) {
		if (this.props.onBoxDown!=undefined)
			this.props.onBoxDown(keyCode,id)
	}

	onBoxActive(id) {
		if (this.props.onBoxActive!=undefined)
			this.props.onBoxActive(id)
	}

	onBoxBlur() {
		if (this.props.onBoxBlur!=undefined)
			this.props.onBoxBlur()
	}

	onBoxDbClick(id) {
		if (this.props.onBoxDbClick!=undefined)
			this.props.onBoxDbClick(id)
	}

	onItemDeleteClick(id) {
		if (this.props.onItemDeleteClick!=undefined)
			this.props.onItemDeleteClick(id)
	}

	onExpandClick(id) {
		if (this.props.onExpandClick!=undefined)
			this.props.onExpandClick(id)
	}

	render() {
		const {connectDragSource,title,left,top,id,isActive,field,showField,isArray,width,text_align,digit} = this.props
		return connectDragSource(
			<div style={getStyles(this.props)}>
				<Box 
					id={id} 
					title={title} 
					left={left} 
					top={top} 
					field={field} 
					isArray={isArray}
					showField={showField} 
					isActive={isActive}
					width={width}
					text_align={text_align}
					digit={digit}
					onBoxDown={this.onBoxDown.bind(this,id)} 
					onBoxActive={this.onBoxActive.bind(this,id)} 
					onBoxBlur={this.onBoxBlur.bind(this)}
					onItemDeleteClick={this.onItemDeleteClick.bind(this,id)}
					onExpandClick={this.onExpandClick.bind(this,id)}
					onBoxDbClick={this.onBoxDbClick.bind(this,id)}
				/>
			</div>
		)
	}
}

export default DragSource('box', boxSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	connectDragPreview: connect.dragPreview(),
	isDragging: monitor.isDragging(),
}))(DraggableBox)


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/DraggableBox.js